import { useTheme } from "#components/theme-provider"
import { RechartsSankeyNode } from "@home-finance-manager/shared/types/dashboard"
import { Layer, Rectangle, Text } from "recharts"

// Custom node component to display node labels directly on nodes
export const SankeyNode = (props: any) => {
  const { x, y, width, height, index, payload } = props
  const nodeData = payload as RechartsSankeyNode
  const isPartner = nodeData?.type === "partner"
  const { resolvedTheme } = useTheme()
  const isDark = resolvedTheme === "dark"

  // Position labels with more spacing from the node rectangle
  // For partners: label on the left side of the node
  // For categories: label on the right side of the node
  // Increased spacing to prevent truncation
  const labelX = isPartner ? (x || 0) - 8 : (x || 0) + (width || 0) + 8
  const labelY = (y || 0) + (height || 0) / 2

  // Theme-aware label colors
  const labelColor = isDark ? "#f9fafb" : isPartner ? "#1f2937" : "#333333"
  const labelWeight = 600
  // Slightly smaller font on mobile for better fit, but still readable
  const labelSize = isPartner ? 12 : 13

  return (
    <Layer key={`CustomNode${index}`}>
      <Rectangle
        x={x}
        y={y}
        width={width}
        height={height}
        fill={nodeData?.color || "#94a3b8"}
        fillOpacity={0.8}
      />
      <Text
        x={labelX}
        y={labelY}
        textAnchor={isPartner ? "end" : "start"}
        verticalAnchor="middle"
        fontSize={labelSize}
        fill={labelColor}
        fontWeight={labelWeight}
        style={{
          pointerEvents: "none",
          textShadow: isDark
            ? "0 1px 4px rgba(0, 0, 0, 0.8), 0 -1px 4px rgba(0, 0, 0, 0.8), 1px 0 4px rgba(0, 0, 0, 0.8), -1px 0 4px rgba(0, 0, 0, 0.8), 0 0 8px rgba(0, 0, 0, 0.5)"
            : "0 1px 3px rgba(255, 255, 255, 0.95), 0 -1px 3px rgba(255, 255, 255, 0.95), 1px 0 3px rgba(255, 255, 255, 0.95), -1px 0 3px rgba(255, 255, 255, 0.95), 0 0 6px rgba(255, 255, 255, 0.8)",
        }}
      >
        {nodeData?.name || ""}
      </Text>
    </Layer>
  )
}
